/* eslint-disable react/destructuring-assignment */
import { Card as CardAntd, CardProps as CardAntdProps } from 'antd';
import cn from 'classnames';
import styled from 'styled-components';

export const Card = (props: CardAntdProps) => {
    const hasOnClick = props.onClick !== undefined;
    const { className } = props;

    return (
        <StyledCard
            {...props}
            className={cn(className, hasOnClick && 'clickable')}
        />
    );
};

const StyledCard = styled(CardAntd)`
    border: 1px solid #e0e0e0;
    border-radius: 0.5rem;

    &.clickable {
        cursor: pointer;

        &:hover {
            border-color: #e0e0e0;
            box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.1);
        }
    }

    &:not(:last-child) {
        margin-bottom: 1rem;
    }
`;
